(function () {

  //console.log('NVZN ART AR Button 2.1.0');

  const nvznAppData = JSON.parse(
    document.getElementById('nvzn-app-data').textContent
  );

  const IMG_SRC_MAX_SIZE = 1024;
  const AR_PRODUCT_TYPES = [
    '2 pices circle',
    'asymmetric mirror',
    'asymmetric wall art',
    'bathroom mirrors',
    'black frame mirrors',
    'canvas',
    'combined',
    'custom',
    'decorative wall mirrors',
    'floor mirror',
    'large wall mirrors',
    'lighted bathroom mirrors',
    'long mirror',
    'metal wall art',
    'mirror art',
    'modern mirror',
    'oil painting',
    'panoramic',
    'round glass wall art',
    'round mirror',
    'suncatcher',
    'surfboard',
  ];
  const AR_PRODUCT_TAGS = ['yataymix', 'dikeymix'];
  const AR_IMAGE_MAP = {
    'horizontal': nvznAppData.product.metafields.nvzn.ar_image_horizontal,
    'vertical': nvznAppData.product.metafields.nvzn.ar_image_vertical,
    'square': nvznAppData.product.metafields.nvzn.ar_image_square,
    'round': nvznAppData.product.metafields.nvzn.ar_image_round,
    'diameter': nvznAppData.product.metafields.nvzn.ar_image_round,
    '2panel': nvznAppData.product.metafields.nvzn.ar_image_2panel,
    '2 pices panel': nvznAppData.product.metafields.nvzn.ar_image_2panel,
    '3 pices panel': nvznAppData.product.metafields.nvzn.ar_image_3panel,
    '5 pices panel': nvznAppData.product.metafields.nvzn.ar_image_5panel,
    'set of 3': nvznAppData.product.metafields.nvzn.ar_image_3set,
    'set of 5': nvznAppData.product.metafields.nvzn.ar_image_5set,
    'panoramic': nvznAppData.product.metafields.nvzn.ar_image_horizontal,
    'panoramic horizontal': nvznAppData.product.metafields.nvzn.ar_image_panoramic_horizontal,
    'panoramic vertical': nvznAppData.product.metafields.nvzn.ar_image_panoramic_vertical,
  };

  const IMG_CROP = {
    center: 'center',
    none: 'none',
  };
  const LOGGER_PREFIX = 'NVZN ART';
  const LOGGER_COLORS = {
    primaryColor: '#696AAB',
    secondaryColor: '#9798CA',
  };
  const PRODUCT_LINK = 'https://apps.shopify.com/nvzn-art';

  let selectedVariantID;

  function init() {
    selectedVariantID = getSelectedVariantId();
    loadProductJson().then(() => {
      enrichVariants();
      updateButtonVisibility();
      if (isProductAREnabled()) {
        logNotice('AR preview enabled ✓');
      } else {
        logger('No AR enabled variants found for this product', 'warn');
      }
    }).catch((error) => {
      console.error(`[${LOGGER_PREFIX}] Initialisation error: ${error.message}`);
    });
  }

  function loadProductJson() {
    return fetch(nvznAppData.product.json_url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        populateProductData(data);
        return data;
      });
  }

  function sanitizeName(name) {
    return name
      .toLowerCase()
      .replace(/\s+-\s+.*$/, '')  // strip " - anything" suffix (option name hints like "Size - (WxH)")
      .replace(/\s+/g, '_')
      .replace(/[()]/g, '')
      .replace(/-/g, '')
      .replace(/\//g, '_')
      .replace(/\./g, '');
  }

  function populateProductData(productData) {
    // Build a map of option position -> sanitized name
    const optionMap = {};
    productData.product.options.forEach(option => {
      optionMap[option.position] = sanitizeName(option.name);
    });
    // Map each variant from product JSON to our variants array
    let variants = productData.product.variants.map(jsonVariant => {
      const variant = {
        id: jsonVariant.id
      };
      // Map option1, option2, option3 to their safe names
      for (let i = 1; i <= 3; i++) {
        const optionKey = `option${i}`;
        const optionValue = jsonVariant[optionKey];
        if (optionValue && optionMap[i]) {
          const safeName = optionMap[i];
          variant[safeName] = optionValue;
        }
      }
      return variant;
    });

    // Convert tags string to array and trim whitespace
    const tags = productData.product.tags.split(',').map(tag => tag.trim());

    nvznAppData.product.product_type = productData.product.product_type;
    nvznAppData.product.tags = tags;
    nvznAppData.product.variants = variants;
  }

  function enrichVariants() {
    nvznAppData.product.variants.forEach((variant) => {

      let imageSource = null;
      let dimensions = null;

      // if not in AR_PRODUCT_TYPES but does have AR_PRODUCT_TAG
      if (
        !isARProductType(nvznAppData.product.product_type) &&
        hasARProductTag(nvznAppData.product.tags)
      ) {
        // DIMENSIONS
        dimensions = extractDimensions(variant.size);
        // IMAGE SOURCE
        imageSource = AR_IMAGE_MAP[variant.style.toLowerCase()];
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.center);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // CANVAS / OIL PAINTING PRODUCTS
      if (
        [
          'canvas',
          'oil painting'
        ].includes(
          nvznAppData.product.product_type.toLowerCase()
        )
      ) {
        // DIMENSIONS
        dimensions = extractDimensions(variant.size);
        if (!dimensions) {
          logger(`Could not parse dimensions for variant ${variant.id}: ${variant.size}`, 'warn');
          variant.arEnabled = false;
          return;
        }
        // IMAGE SOURCE
        // Determine orientation and select appropriate image source
        if (dimensions.width == dimensions.height) {
          // Square or round image (with horizontal or vertical fallback)
          imageSource = AR_IMAGE_MAP.square || AR_IMAGE_MAP.round || AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.vertical;
        } else if (dimensions.width > dimensions.height) {
          // Horizontal/landscape image
          imageSource = AR_IMAGE_MAP.horizontal;
        } else if (dimensions.width < dimensions.height) {
          // Vertical/portrait image
          imageSource = AR_IMAGE_MAP.vertical;
        }
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // METAL WALL ART PRODUCTS
      if (
        ['metal wall art'].includes(nvznAppData.product.product_type.toLowerCase())
      ) {
        // DIMENSIONS
        dimensions = extractDimensions(variant.size);
        if (!dimensions) {
          logger(`Could not parse dimensions for variant ${variant.id}: ${variant.size}`, 'warn');
          variant.arEnabled = false;
          return;
        }

        // IMAGE SOURCE
        if (variant.style) {
          const style = variant.style.toLowerCase();
          if (style === 'horizontal') {
            // Priority: horizontal || vertical || square || round
            imageSource = AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.vertical || AR_IMAGE_MAP.square || AR_IMAGE_MAP.round;
          } else if (style === 'vertical') {
            // Priority: vertical || horizontal || square || round
            imageSource = AR_IMAGE_MAP.vertical || AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.square || AR_IMAGE_MAP.round;
          } else {
            // Fallback for other styles
            imageSource = AR_IMAGE_MAP[style] || AR_IMAGE_MAP.vertical || AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.square || AR_IMAGE_MAP.round;
          }
        } else {
          // If no style, prioritise vertical: vertical || horizontal || square || round
          imageSource = AR_IMAGE_MAP.vertical || AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.square || AR_IMAGE_MAP.round;
        }

        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // MULTI_PANEL / COMBINED PRODUCTS
      if (
        [
          'combined'
        ].includes(nvznAppData.product.product_type.toLowerCase())
      ) {
        // if Size and Total Size properties
        if (variant.size && variant.total_size) {
          // DIMENSIONS
          dimensions = extractDimensions(variant.total_size);
          // IMAGE SOURCE
          // use Size to determine AR image
          imageSource = AR_IMAGE_MAP[variant.size.toLowerCase()];
        } else if (variant.size && !variant.total_size) {
          // if only Size property
        } else if (variant.total_size && !variant.size) {
          // if only Total Size property
        }
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // PANORAMIC PRODUCTS
      if (
        ['panoramic'].includes(nvznAppData.product.product_type.toLowerCase())
      ) {
        // DIMENSIONS
        if (variant.size) {
          dimensions = extractDimensions(variant.size);
          if (!dimensions) {
            logger(`Could not parse dimensions for variant ${variant.id}: ${variant.size}`, 'warn');
            variant.arEnabled = false;
            return;
          }
          if (
            variant.style.toLowerCase() == 'set of 5' &&
            variant.size.toLowerCase().endsWith('x5')
          ) {
            dimensions.width *= 5;
          }
        }
        if (variant.total_size) {
          dimensions = extractDimensions(variant.total_size);
        }
        // IMAGE SOURCE
        imageSource = AR_IMAGE_MAP[variant.style.toLowerCase()];
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // "2 Pices Circle", use Total Size
      if (
        ['2 pices circle'].includes(
          nvznAppData.product.product_type.toLowerCase()
        )
      ) {
        // extract dimensions from total_size_wh
        dimensions = extractDimensions(variant.total_size_wh);
        // IMAGE SOURCE
        imageSource = AR_IMAGE_MAP['2panel'];
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // common types
      if (
        [
          'asymmetric wall art',
          'round mirror',
          'asymmetric mirror',
          'mirror art',
          'decorative wall mirrors',
          'modern mirror',
          'floor mirror',
          'long mirror',
          'bathroom mirrors',
          'black frame mirrors',
          'large wall mirrors',
          'lighted bathroom mirrors',
          'suncatcher',
          'round glass wall art',
          'surfboard',
          'custom',
        ].includes(nvznAppData.product.product_type.toLowerCase())
      ) {
        dimensions = extractDimensions(variant.size);
        if (!dimensions) {
          logger(`Could not parse dimensions for variant ${variant.id}: ${variant.size}`, 'warn');
          variant.arEnabled = false;
          return;
        }
        // if has a style property...
        if (variant.style) {
          if (variant.style.toLowerCase() == 'horizontal' || variant.style.toLowerCase() == 'panoramic horizontal') {
            dimensions = orientateDimensions(dimensions, 'horizontal');
          }
          if (variant.style.toLowerCase() == 'vertical' || variant.style.toLowerCase() == 'panoramic vertical') {
            dimensions = orientateDimensions(dimensions, 'vertical');
          }
          imageSource = AR_IMAGE_MAP[variant.style.toLowerCase()];
        } else {
          // if no style, and multiple image sources
          if (getAvailableARImageCount() > 1) {
            if (variant.size.toLowerCase().includes('horizontal')) {
              // horizontal
              dimensions = orientateDimensions(dimensions, 'horizontal');
              imageSource = AR_IMAGE_MAP.horizontal;
            } else if (variant.size.toLowerCase().includes('vertical')) {
              // vertical
              dimensions = orientateDimensions(dimensions, 'vertical');
              imageSource = AR_IMAGE_MAP.vertical;
            } else if (variant.size.toLowerCase().includes('diameter')) {
              // round
              imageSource = AR_IMAGE_MAP.diameter;
            } else {
              // presume square
              imageSource = AR_IMAGE_MAP.square;
            }
          } else if (getAvailableARImageCount() == 1) {
            if (AR_IMAGE_MAP.horizontal) dimensions = orientateDimensions(dimensions, 'horizontal');
            if (AR_IMAGE_MAP.vertical) dimensions = orientateDimensions(dimensions, 'vertical');
            imageSource = AR_IMAGE_MAP.horizontal || AR_IMAGE_MAP.vertical || AR_IMAGE_MAP.square || AR_IMAGE_MAP.round;
          }
        }
        // SET VARIANT
        variant.imageSource = formatImageURL(imageSource, dimensions, IMG_CROP.none);
        variant.dimensions = dimensions;
        variant.arEnabled = Boolean(imageSource && dimensions);
        return; // Skip to the next variant
      }

      // no match
      logger(
        `No AR product match for ${nvznAppData.product.product_type} variant ID: ${variant.id}`,
        'warn'
      );
    });

    if (nvznAppData.nvznart.logging) {
      console.groupCollapsed(`[${LOGGER_PREFIX}] Product Variants`);
      console.dir(nvznAppData.product.variants);
      console.groupEnd();
    }
  }

  function getAvailableARImageCount() {
    const metafields = nvznAppData.product.metafields.nvzn;
    let uniqueImages = new Set();
    // Loop through all properties in the metafields object
    for (const key in metafields) {
      // Check if property starts with ar_image_ and has a value
      if (key.startsWith('ar_image_') && metafields[key]) {
        uniqueImages.add(metafields[key]);
      }
    }
    return uniqueImages.size;
  }

  function isARProductType(productType) {
    if (AR_PRODUCT_TYPES.includes(productType.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  function hasARProductTag(tags) {
    for (const tag of tags) {
      if (AR_PRODUCT_TAGS.includes(tag.toLowerCase())) {
        return true;
      }
    }
    return false;
  }

  function isProductAREnabled() {
    return nvznAppData.product.variants.some((variant) => variant.arEnabled);
  }

  function orientateDimensions(dimensions, orientation) {
    if (!dimensions) return null;
    // Create a copy of dimensions to avoid modifying the original
    const result = { ...dimensions };
    if (orientation === 'horizontal' && dimensions.width < dimensions.height) {
      // Swap for horizontal orientation
      result.width = dimensions.height;
      result.height = dimensions.width;
      return result;
    } else if (
      orientation === 'vertical' &&
      dimensions.width > dimensions.height
    ) {
      // Swap for vertical orientation
      result.width = dimensions.height;
      result.height = dimensions.width;
      return result;
    }
    return dimensions; // Return original if no swap needed
  }

  // Handle variant change events
  document.addEventListener('change', function (event) {
    // Check if the change is from a variant selector
    if (event.target.matches('select[data-variant-input]')) {
      // get the selected variant ID
      selectedVariantID = getSelectedVariantId();
      logger(`Selected variant ID: ${selectedVariantID}`, 'log');
      updateButtonVisibility();
    }
  });

  function updateButtonVisibility() {
    logger('Updating AR button visibility', 'log');

    const arButtonContainer = document.querySelector(
      '.nvznart-arbutton-container'
    );
    const arButtonElement = document.getElementById('nvznart-arbutton');
    const variant = getVariant(getSelectedVariantId());

    // remove loading
    arButtonContainer.classList.remove('loading');

    // if design mode, always display the button as active
    if (nvznAppData.request.design_mode) {
      logger('Design mode enabled, showing AR button', 'log');
      arButtonContainer.classList.add('show');
      arButtonElement.disabled = false;
      return;
    }

    if (!variant) {
      logger(`No variant found for ID: ${selectedVariantID}`, 'warn');
      arButtonContainer.classList.add('remove');
      arButtonElement.disabled = true;
      return;
    }

    // if no AR enabled variants, hide the button
    if (!isProductAREnabled()) {
      logger('No AR enabled variants, removing button', 'log');
      arButtonContainer.classList.add('remove');
      arButtonElement.disabled = true;
      return;
    }

    // if some AR enabled variants, but this variant is not one of them, disable the button
    if (isProductAREnabled() && !variant.arEnabled) {
      logger('Variant not AR enabled', 'log');
      arButtonContainer.classList.add('show');
      arButtonElement.disabled = true;
      return;
    }

    if (variant && variant.arEnabled) {
      logger('AR enabled for this variant', 'log');
      arButtonContainer.classList.add('show');
      arButtonContainer.classList.remove('remove');
      arButtonElement.disabled = false;
      return;
    }

    logger('Unknown AR button state', 'warn');
  }

  // button click events
  document
    .getElementById('nvznart-arbutton')
    .addEventListener('click', (event) => {
      const variant = getVariant(selectedVariantID);
      if (variant && variant.arEnabled) {
        viewARVariant(variant);
      } else {
        alert('AR not enabled for this variant');
      }
    });

  function viewARVariant(variant) {
    logger('View AR Variant', 'log');
    logger('Variant ID: ' + variant.id, 'log');
    logger('language: ' + nvznAppData.request.language, 'log');
    // external API
    openNvznArtPreview({
      accountID: nvznAppData.shop.metafields.nvzn.nvzn_id,
      productID: variant.id,
      imageSource: variant.imageSource,
      width: variant.dimensions.width,
      height: variant.dimensions.height,
      units: variant.dimensions.units,
      tracking: nvznAppData.nvznart.tracking,
      language: nvznAppData.request.language,
    });
  }

  function getSelectedVariantId() {
    return (
      new URLSearchParams(window.location.search).get('variant') ||
      String(nvznAppData.product.selected_or_first_available_variant.id)
    );
  }

  function getVariant(id) {
    return nvznAppData.product.variants.find((variant) => String(variant.id) === String(id));
  }

  function extractDimensions(size) {
    if (!size) return null;

    // Define all dimension patterns with type and description
    const patterns = [
      // Circular patterns
      {
        type: 'circular',
        pattern: /^\s*(\d+\.?\d*)\s*(?:['\u2018\u2019]{2}|\u2033|")(?!\s*x)/i,
        description: "123'' (circular: single dimension, no x separator)",
        // Matches:
        // - "20''-(50 cm)"         (ASCII single quotes)
        // - "20\u2019\u2019-(50 cm)"         (Unicode curly quotes)
        // - "19.6'' Diameter – (50cm)"
        // - "20'' (50 cm Diameter)"
        // - "20''-(50cm Diameter)"
        // Does NOT match: "59x23.6''(Horizontal)"
      },
      {
        type: 'rectangular',
        pattern: /^\s*\d+\s*-\s*(\d+\.?\d*)\s*x\s*(\d+\.?\d*)\s*''/i,
        description: "Leading number-dash, then 123x123'' (ignore after)",
        // 1- 38x40''-97x100 cm
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*x\s*(\d+\.?\d*)\s*"/i,
        description: '123 x 123 "',
        // 18x59"(46x150cm)
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*x\s*(\d+\.?\d*)\s*''/i,
        description: "123 x 123 ''",
        // 59x23.6''(Horizontal)
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*x\s*(\d+\.?\d*)\s*inches/i,
        description: '123 x 123 inches',
        // 23 x 63 inches ( 60 x 160 cm)
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*x\s*(\d+\.?\d*)\s*'/i,
        description: "Error 123 x 123 '",
        // 43 x 27.5' (Horizontal)
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*W\s*[x\u00D7]\s*(\d+\.?\d*)\s*H\s*(?:['\u2018\u2019]{2}|\u2033|")/i,
        description: "123Wx123H'' (with Unicode quote support)",
        // 23Wx12H'' (60x30cm)
        // 71Wx28H''(180x72cm)  (Unicode curly quotes)
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*W\s*x\s*(\d+\.?\d*)\s*H\s*inches/i,
        description: '123W x 123H inches',
        // 22W x 35.4H inches ( 56 x 90 cm )
      },
      {
        type: 'rectangular',
        pattern: /^\s*(\d+\.?\d*)\s*W\s*[x\u00D7]\s*(\d+\.?\d*)\s*H\s*[\u2033"'']?\s*-/i,
        description: '123W×123H″- or 123W×123H- (with or without inch mark)',
        // 12W×18H″-(30x45cm)
        // 14W×14H-(35x35cm)
      },
    ];

    // Process each pattern in order
    for (const { type, pattern, description } of patterns) {
      const matches = size.match(pattern);
      if (matches) {
        if (type === 'circular') {
          const diameter = parseFloat(matches[1]);
          return {
            width: diameter,
            height: diameter,
            units: 'in',
          };
        } else if (type === 'rectangular') {
          const width = parseFloat(matches[1]);
          const height = parseFloat(matches[2]);
          return {
            width,
            height,
            units: 'in',
          };
        }
      }
    }

    logger(`Could not extract dimensions from size: ${size}`, 'error');
    return null;
  }

  function formatImageURL(url, dimensions, cropMethod = IMG_CROP.none) {
    if (!url || !dimensions) return url;
    try {
      // Calculate dimensions with max size limit if needed
      const maxDimension = Math.max(dimensions.width, dimensions.height);
      const scale = IMG_SRC_MAX_SIZE / maxDimension;
      const width = Math.round(dimensions.width * scale);
      const height = Math.round(dimensions.height * scale);

      // Check if the URL already has query parameters
      const hasQueryParams = url.includes('?');

      // Construct query string with appropriate separator
      const separator = hasQueryParams ? '&' : '?';

      // Add width, height, crop, and format as query parameters
      let formattedUrl = `${url}${separator}`;

      if (cropMethod == IMG_CROP.center) {
        formattedUrl += `width=${width}&height=${height}&crop=center&format=webp`;
      } else {
        if (dimensions.width >= dimensions.height) {
          formattedUrl += `width=${IMG_SRC_MAX_SIZE}&format=webp`;
        } else {
          formattedUrl += `height=${IMG_SRC_MAX_SIZE}&format=webp`;
        }
      }
      return formattedUrl;
    } catch (error) {
      console.error(`[${LOGGER_PREFIX}] Error formatting URL: ${error.message}`);
      return url; // Return original URL if any errors
    }
  }

  function logger(message, type = 'log') {
    if (nvznAppData.nvznart.logging) {
      message = `[${LOGGER_PREFIX}] ${message}`;
      switch (type) {
        case 'log':
          console.log(message);
          break;
        case 'warn':
          console.warn(message);
          break;
        case 'error':
          console.error(message);
          break;
        default:
          console.log(message);
      }
    }
  }

  function logNotice(message) {
    console.log(
      `%c ${LOGGER_PREFIX} %c ${message} %c Discover more at ${PRODUCT_LINK}`,
      `background: ${LOGGER_COLORS.primaryColor}; color: white; font-family: Tahoma, sans-serif; font-weight: bold; padding: 4px 6px 4px 10px; border-radius: 20px 0 0 20px; white-space: nowrap;`,
      `background: ${LOGGER_COLORS.secondaryColor}; color: white; font-family: Tahoma, sans-serif; font-weight: normal; padding: 4px 10px 4px 6px; border-radius: 0 20px 20px 0; margin-right: 12px; white-space: nowrap;`,
      `color: #525252; font-family: Tahoma, sans-serif; font-weight: normal; font-size: 0.8em; white-space: nowrap;`
    );
  }

  init();
})();
